import classnames from 'classnames';
import React from 'react';

import {translate} from 'iss/strings';
import {ErrorBox} from 'iss/widgets/MessageBox';

export function BootstrapFormGroup({label, error, id, children, className, helpText, noTranslateLabel}) {
  const containerClass = classnames('form-group',  {"has-error has-feedback": error}, className);

  return <div id={id+"-container"} className={containerClass}>
    {label ? <label className="control-label" htmlFor={id}>{noTranslateLabel ? label : translate(label)}</label> : null }
    {children}
    {helpText ? <small id={id+"-help-text"} htmlFor={id} className="form-text">{translate(helpText)}</small> : null }
    <ErrorBox id={id+"-error"} className='form-error' message={error} />
  </div>;
}

export default BootstrapFormGroup;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/bootstrap/FormGroup.jsx